export default "__VITE_ASSET__DugMMjNv__"